define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MediaRegion = void 0;
    var MediaRegion;
    (function (MediaRegion) {
        MediaRegion["GLL"] = "gll";
        MediaRegion["AU1"] = "au1";
        MediaRegion["BR1"] = "br1";
        MediaRegion["DE1"] = "de1";
        MediaRegion["IE1"] = "ie1";
        MediaRegion["IN1"] = "in1";
        MediaRegion["JP1"] = "jp1";
        MediaRegion["SG1"] = "sg1";
        MediaRegion["US1"] = "us1";
        MediaRegion["US2"] = "us2";
    })(MediaRegion = exports.MediaRegion || (exports.MediaRegion = {}));
});
